<template>
  <div class="container">
    <div class="main">
      <p class="tips red" v-if="noIP">{{ noIP }}</p>
      <!-- <p class="tips" v-else><i class="el-icon-warning"></i>账号：{{ name }}，密码：{{ pwd }}</p> -->

      <!-- <h3>{{ titlename }}</h3> -->
      <div class="tab">
        <ul>
          <li @click="handleChangeTab(1)" :class="{ checked: tabIndex == 1 }">
            账号注册
          </li>
          <!-- <li @click="handleChangeTab(2)" :class="{ checked: tabIndex == 2 }">
            统一认证登录
          </li> -->
        </ul>
      </div>
      <div class="loginForm" v-if="tabIndex == 1">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <el-form-item prop="userName">
            <div class="inputDiv">
              <!-- <img src="@/assets/images/user.png" /> -->
              <el-input
                type="name"
                v-model="ruleForm.userName"
                maxlength="20"
                clearable
                placeholder="请输入用户名"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item prop="nickName">
            <div class="inputDiv">
              <!-- <img src="@/assets/images/user.png" /> -->
              <el-input
                type="name"
                v-model="ruleForm.nickName"
                maxlength="20"
                clearable
                placeholder="请输入昵称"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <div class="inputDiv">
              <!-- <img src="@/assets/images/password.png" /> -->
              <el-input
                type="password"
                clearable
                v-model="ruleForm.password"
                placeholder="请输入密码"
                maxlength="20"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item prop="password2">
            <div class="inputDiv">
              <!-- <img src="@/assets/images/password.png" /> -->
              <el-input
                type="password"
                clearable
                v-model="ruleForm.password2"
                placeholder="请输入确认密码"
                maxlength="20"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item prop="phonenumber">
            <div class="inputDiv">
              <!-- <img src="@/assets/images/grzx-ghsjh.png" /> -->
              <el-input
                type="name"
                v-model="ruleForm.phonenumber"
                clearable
                placeholder="请输入手机号"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item prop="email">
            <div class="emailcode">
              <el-input
                type="name"
                v-model="ruleForm.email"
                clearable
                placeholder="请输入邮箱"
              >
              </el-input>
              <span class="code" v-if="showcode" @click="getCode"
                >发送验证码</span
              >
              <span class="code" v-else>{{ times }}</span>
            </div>
          </el-form-item>

          <el-form-item prop="mailCode">
            <div class="inputDiv">
              <!-- <img src="@/assets/images/grzx-e.png" /> -->
              <el-input
                type="name"
                v-model="ruleForm.mailCode"
                clearable
                placeholder="请输入邮箱验证码（区分大小写）"
                @keyup.enter.native="submitForm('ruleForm')"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item class="btn">
            <el-button type="primary" @click="submitForm('ruleForm')"
              >注册</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="loginuser">已有账号,去<span @click="tologin">登录</span></div>
    </div>
    <p class="login-bottom">版权所有 江苏畅想之星信息技术有限公司</p>
  </div>
</template>

<script>
import axios from "axios";
import urlSet from "@/api/baseurl.js";
export default {
  data() {
    return {
      tabIndex: 1,
      noIP: "", //有值 不在ip范围内，否则 在ip范围内
      ruleForm: {
        userName: "",
        password: "",
        nickName: "",
        password2: "",
        phonenumber: "",
        email: "",
        mailCode: "",
      },
      name: "",
      pwd: "",
      rules: {
        userName: [
          { message: "请输入用户名", required: true, trigger: "blur" },
          {
            message: "请输入5-20个字符用户名",
            required: true,
            trigger: "blur",
            min: 5,
            max: 20,
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
                return;
              }
              this.$http({
                url: "/api/v1/tourist/check/username?userName=" + value,
                method: "GET",
              }).then((res) => {
                if (res.data) {
                  callback();
                } else {
                  callback(new Error("用户名已存在"));
                }
              });
            },
            trigger: "blur",
          },
        ],
        password: [
          { message: "请输入密码", required: true, trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "密码长度必须介于6和20之间",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (this.ruleForm.password2) {
                if (value !== this.ruleForm.password2) {
                  callback(new Error("两次密码不一致"));
                } else {
                  callback();
                }
              }
            },
            trigger: "blur",
          },
        ],
        password2: [
          { message: "请输入确认密码", required: true, trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "确认密码长度必须介于6和20之间",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (this.ruleForm.password) {
                if (value !== this.ruleForm.password) {
                  callback(new Error("两次密码不一致"));
                } else {
                  callback();
                }
              }
            },
            trigger: "blur",
          },
        ],
        phonenumber: [
          {
            pattern: /^[1][3,4,5,6.7,8,9][0-9]{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        email: [
          { message: "请输入邮箱", required: true, trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
            message: "邮箱格式不正确",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
                return;
              }
              this.$http({
                url: "/api/v1/tourist/check/email?email=" + value,
                method: "GET",
              }).then((res) => {
                if (res.data) {
                  callback();
                } else {
                  callback(new Error("邮箱已存在"));
                }
              });
            },
            trigger: "blur",
          },
        ],
        mailCode: [
          { message: "请输入邮箱验证码", required: true, trigger: "blur" },
        ],
      },
      titlename: "外文学术资源数据库",
      showcode: true,
      times: 60,
    };
  },
  created() {},
  mounted() {
    if (this.$route.query.asp) {
      this.titlename = "文献服务平台";
    }
  },
  methods: {
    // 获取验证码
    getCode() {
      this.$refs.ruleForm.validateField(["email"], (valid) => {
        if (!valid) {
          this.times = 60;
          this.showcode = false;
          this.timer = setInterval(() => {
            this.times--;
            if (this.times === 0) {
              this.showcode = true;
              clearInterval(this.timer);
            }
          }, 1000);
          this.$http({
            url: "api/v1/tourist/send/code?email=" + this.ruleForm.email,
            method: "get",
          }).then((res) => {
            if (res.code == 200) {
            }
          });
        }
      });
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let postBody = {
            userName: this.ruleForm.userName.trim(),
            nickName: this.ruleForm.nickName.trim(),
            password: this.ruleForm.password.trim(),
            phonenumber: this.ruleForm.phonenumber.trim(),
            email: this.ruleForm.email.trim(),
            mailCode: this.ruleForm.mailCode.trim(),
          };
          this.$http({
            url: "/api/v1/tourist/add/user",
            method: "POST",
            data: postBody,
          }).then((res) => {
            if (res.code == 200) {
              this.$message.success("注册成功");
              setTimeout(() => {
                this.$router.push({ path: "/lg?word=true" });
              }, 1500);
            }
          });
        } else {
          return false;
        }
      });
    },
    tologin() {
      if (this.$route.query.asp) {
        this.$router.push({
          path: "/lg?word=true&asp=true",
        });
      } else {
        this.$router.push({ path: "/lg?word=true" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  min-width: calc(100vw);
  min-height: calc(100vh);
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("../../assets/images/bg.png") no-repeat;
  background-size: cover;
  .login-bottom {
    position: absolute;
    text-align: center;
    bottom: 20px;
    color: #fff;
    font-size: 14px;
  }
  .main {
    position: relative;
    border-radius: 0px;
    background: #ffffff;
    min-height: 390px;
    width: 450px;
    padding: 30px 25px 25px 25px;
    box-shadow: -6px 0px 12px 6px rgba(0, 0, 0, 0.1);
    h3 {
      text-align: center;
      margin-bottom: 20px;
      color: #2d8cf0;
      font-size: 22px;
    }
    .tips {
      position: absolute;
      top: 10px;
      left: 10px;
      font-size: 14px;
      color: #bcbcbc;
      i {
        margin-right: 5px;
      }
    }
    .ipTips {
      font-size: 14px;
      i {
        margin-right: 5px;
      }
    }
    .red {
      color: #fa0000 !important;
    }
  }
  .loginForm {
    min-width: 240px;
    padding: 0 40px;
    .el-select {
      width: 100%;
    }
    .el-button {
      width: 100%;
      //   margin-top: 20px;
    }
    .inputDiv {
      display: flex;
      align-items: center;
      border: 1px solid #dcdfe6;
      border-radius: 5px;
      position: relative;
      //   &::after {
      //     content: "";
      //     position: absolute;
      //     left: 43px;
      //     height: 23px;
      //     top: 50%;
      //     margin-top: -12px;
      //     width: 1px;
      //     display: inline-block;
      //     background: #2d8cf0;
      //   }

      ::v-deep .el-input {
        // padding-left: 10px;
        .el-input__inner {
          border: none;
        }
      }
      img {
        width: 23px;
        height: 23px;
        margin-left: 10px;
        position: relative;
      }
    }
    .emailcode {
      align-items: center;
      position: relative;
      flex: 1;
      border: 1px solid #dcdfe6;
      border-radius: 5px;
      ::v-deep .el-input {
        width: 220px;
        .el-input__inner {
          border: none;
        }
      }
      .code {
        position: absolute;
        right: 0;
        width: 100px;
        text-align: center;
        color: #2d8cf0;
        top: 0;
        line-height: 40px;
        cursor: pointer;
        &::after {
          position: absolute;
          left: 0;
          width: 1px;
          height: 23px;
          background: #2d8cf0;
          content: "";
          top: 8px;
        }
      }
    }
    .tab2-btn {
      margin-top: 20px;
    }
  }
  .tab {
    padding: 0 70px;
    border-bottom: 1px solid #dcdfe6;
    padding-bottom: 20px;
    margin-bottom: 30px;
    ul {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    li {
      color: #666666;
      font-size: 18px;
      cursor: pointer;
      position: relative;
      margin: 0 20px;
    }
    .checked {
      color: #2d8cf0;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -21px;
        height: 2px;
        width: 100%;
        background: #2d8cf0;
      }
    }
  }
  .loginuser {
    font-size: 14px;
    color: #666666;
    width: 320px;
    margin: 0px auto;
    span {
      color: #2d8cf0;
      margin-left: 5px;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
